import { Component, OnInit, OnDestroy, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { DataDefinitionList } from './data-definition.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'data-definition',
  templateUrl: './data-definition.component.html',
  styleUrls: ['./data-definition.component.css']
})
export class DataDefinitionComponent implements OnInit, OnDestroy {
  // dataDef: DataDefinition[] = [];
  // selectedDataDefListCategoryId: number;
  // selectedDataDefListId: number;
  selectedDataDefList: DataDefinitionList;
  // dataDefList: DataDefinitionList[] = [];
  // dataDefFilteredList: DataDefinitionList[] = [];
  // dataDefListCategories: DataDefinitionList[] = [];
  subscriptions: Subscription[] = [];
  addClick: EventEmitter<any> = new EventEmitter<any>();
  saveSequenceClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataDefinitionList,
    private dialogRef: MatDialogRef<DataDefinitionComponent>
  ) {
    this.selectedDataDefList = data;
  }

  ngOnInit() {
    // this.getDataDefinitionList();
  }

  closeClick() {
    this.dialogRef.close();
  }

  ngOnDestroy() {}

  // getDataDefinitionList() {
  //   this.subscriptions.push(this.dataDefinitionService.getDataDefinitionList().subscribe(dataDefList => {
  //     if (dataDefList && dataDefList.length > 0) {
  //       this.dataDefList = dataDefList;
  //       this.dataDefListCategories = dataDefList.filter((value, i, arr) => {
  //         return arr.indexOf(arr.find(t => t.LookupListCategoryName === value.LookupListCategoryName)) === i;
  //       });

  //       this.selectedDataDefListCategoryId = dataDefList[0].LookupListCategoryId;
  //       this.selectedDataDefListId = dataDefList[0].Id;
  //       this.selectedDataDefList = dataDefList[0];
  //       this.dataDefFilteredList = this.dataDefList.filter(lst => lst.LookupListCategoryId === this.selectedDataDefListCategoryId);
  //     }
  //   }));
  // }

  // selectedDataDefListCategoryChanged(selectedDataDefListCategoryId: any) {
  //   this.dataDefFilteredList = this.dataDefList.filter(lst => lst.LookupListCategoryId === selectedDataDefListCategoryId);
  //   this.selectedDataDefListId = this.dataDefFilteredList[0].Id;
  //   this.selectedDataDefList = this.dataDefFilteredList[0];
  // }

  // selectedDataDefListChanged(selectedLookupListId: any) {
  //   this.selectedDataDefListId = selectedLookupListId;
  //   this.selectedDataDefList = this.dataDefFilteredList.filter(lst => lst.Id === this.selectedDataDefListId)[0];
  // }
}
